import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import SweetAlert from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

var localizedFormat = require('dayjs/plugin/localizedFormat')
const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
const MySweetAlert = withReactContent(SweetAlert)

const helper = {
  dateFormat: date => {
    if (date) {
      const Date = dayjs(date).format('LLL')
      return Date
    }
  },
  dobFormat: date => {
    if (date) {
      const Date = dayjs(date).format('LL')
      return Date
    }
  },
  remainingTimeFromNow: date => {
    if (date) {
      const Date = dayjs(date).fromNow()
      return Date
    }
  },
  isInputNumber: event => {
    const char = String.fromCharCode(event.which)
    if (!/[0-9]/.test(char)) {
      event.preventDefault()
    }
  },
  alertFunction: (title, item, changeFunction, deleteIcon) => {
    MySweetAlert.fire({
      // title: <h3>{title}</h3>,
      html: <strong>{title}</strong>,
      icon: deleteIcon ? 'error' : 'warning',
      showConfirmButton: 'Okay',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        changeFunction(item)
      }
    })
  },
  alertFunctionService: (title, item, changeFunction, deleteIcon) => {
    MySweetAlert.fire({
      // title: <h3>{title}</h3>,
      html: <strong className='px-3'>{title}</strong>,
      icon: deleteIcon ? 'error' : 'warning',
      showConfirmButton: 'Okay',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        changeFunction(item)
      }
    })
  },
  downloadSampleDistrictFile: url => {

    if (isEmpty(url)) {
      alert('Invalid URL')
      return false
    }
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(xhr.response)
      a.href = url
      a.download = 'sample_districts'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    xhr.send()
  },
  downloadSampleUpazilaFile: url => {

    if (isEmpty(url)) {
      alert('Invalid URL')
      return false
    }
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(xhr.response)
      a.href = url
      a.download = 'sample_upazilas'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    xhr.send()
  },
  downloadSampleUnionFile: url => {

    if (isEmpty(url)) {
      alert('Invalid URL')
      return false
    }
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(xhr.response)
      a.href = url
      a.download = 'sample_unions'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    xhr.send()
  },
}

export default helper
